import {
  signInWithRedirect,
  signInWithPopup,
  getRedirectResult,
  FacebookAuthProvider,
  getAdditionalUserInfo,
} from 'firebase/auth'
import {
  FirebaseAuthResponse,
  FirebaseAuthResponseError,
  FirebaseAuthResponseSuccess,
} from '../types'
import { auth } from './firebaseAuth'

const facebookProvider = new FacebookAuthProvider()

export const facebookAuthRedirect = function () {
  return signInWithRedirect(auth, facebookProvider)
}

export const facebookAuth = function (
  bPopup: boolean
): Promise<FirebaseAuthResponse | undefined> {
  return (bPopup
    ? signInWithPopup(auth, facebookProvider)
    : getRedirectResult(auth)
  )
    .then((result) => {
      if (!result) return
      const credential = FacebookAuthProvider.credentialFromResult(result)
      if (!credential) return
      const user = getAdditionalUserInfo(result)
      if (!user) return
      const avatar: any =
        typeof user?.profile?.picture === 'string'
          ? user.profile.picture
          : (user.profile?.picture as any)?.data?.url
      const payload: FirebaseAuthResponseSuccess = {
        type: 'success',
        id: String(user?.profile?.id || ''),
        email: String(user?.profile?.email || ''),
        firstName: String(user?.profile?.first_name || ''),
        lastName: String(user?.profile?.last_name || ''),
        avatar: String(avatar || ''),
      }
      return payload
    })
    .catch((error) => {
      console.error(error)
      const response: FirebaseAuthResponseError = {
        type: 'error',
        code: error.code,
        message: error.message,
        email: error.email,
      }
      return response
    })
}
